module.exports = __webpack_public_path__ + "credito-20-m-knR.png";